// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"94c649d8","710":"a4c71656"}[chunkId] + ".chunk.js";
};